import CreditNoteTotals from './CreditNoteTotals';
import DebitNoteTotals from './DebitNoteTotals';
import ExcludedSubjectTotals from './ExcludedSubjectTotals';
import TaxCreditTotals from './TaxCreditTotals';
import { DOCUMENT_TYPES } from '../../../constants/purchase';

interface Props {
  documentTypeId?: number;
  form: any;
  readOnly?: boolean;
}

const TotalsDisplay = ({ documentTypeId, form, readOnly = false }: Props) => {
  switch (documentTypeId) {
    case DOCUMENT_TYPES.EXCLUDED_SUBJECT:
      return <ExcludedSubjectTotals form={form} />;
    case DOCUMENT_TYPES.CREDIT_NOTE:
      return <CreditNoteTotals form={form} />;
    case DOCUMENT_TYPES.TAX_CREDIT:
      return <TaxCreditTotals form={form} readOnly={readOnly} />;
    case DOCUMENT_TYPES.DEBIT_NOTE:
      return <DebitNoteTotals form={form} />;
    default:
      return null;
  }
};

export default TotalsDisplay;
